<template>
    <div class="dropdown dropdown-top dropdown-end" v-if="$route.meta.type != 'cart'" ref="dropdownRef">
        <label tabindex="0" @click.stop="toggleDropdown">
            <ChartBarIcon class="w-4 h-4 text-info inline-block cursor-pointer ml-1" />
        </label>
        <div v-if="isOpen" tabindex="0" class="mt-3 card card-compact dropdown-content w-56 bg-base-100 shadow">
            <div class="card-body">
                <p class="flex justify-between">
                    <span>{{ __('Price') }}:</span>
                    <span :class="[price > old_price ? 'text-error' : 'text-success']" v-if="price">
                        <span>({{ discount(price, old_price) }}%)</span>
                        {{ price.toLocaleString() }}
                        <Currency class="!mr-0" />
                    </span>
                    <span class="text-info" v-else>{{ __('Price is changing.') }}</span>
                </p>
                <p class="flex justify-between">
                    <span>{{ __('Previous price') }}:</span>
                    <span>
                        {{ old_price.toLocaleString() }}
                        <Currency class="!mr-0" />
                    </span>
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { ChartBarIcon } from '@heroicons/vue/24/outline';
import Currency from '../../svg/Currency.vue';
import { discount } from '@/util.js';

defineProps(['price', 'old_price']);

const isOpen = ref(false);
const dropdownRef = ref(null);
defineExpose({ isOpen });
function toggleDropdown() {
    isOpen.value = !isOpen.value;
}

function handleClickOutside(e) {
    if (dropdownRef.value && !dropdownRef.value.contains(e.target)) {
        isOpen.value = false;
    }
}

onMounted(() => document.addEventListener('click', handleClickOutside));
onUnmounted(() => document.removeEventListener('click', handleClickOutside));
</script>